/**
 * @module
 * @description A place to store the users current locale
 * @example
 * // In your @/store
 * import Vue from 'vue';
 * import Vuex from 'vuex';
 * import tokeny from '@tokenyico/vuejs-toolkit/src/exports/store/tokeny';
 * import locale from '@tokenyico/vuejs-toolkit/src/exports/store/locale';
 * import persist from '@tokenyico/vuejs-toolkit/src/exports/store/persist';
 * Vue.use(Vuex);
 * export default new Vuex.Store({
 *   modules: { locale, tokeny },
 *   plugins: [persist.plugin]
 * });
 *
 * // In your VueJS component
 * import { mapActions, mapGetters } from 'vuex';
 * export default {
 *   computed: {
 *    ...mapGetters({
 *      locale: 'locale/locale',
 *      locales: 'locale/locales'
 *    })
 *  },
 *  methods: {
 *    ...mapActions({
 *      setLocale: 'locale/setLocale'
 *    }),
 *   }
 * };
 */
import { locales } from '../i18n';

export default {
  namespaced: true,
  /**
   * @name state
   * @type {object}
   * @property {string} locale The current local
   */
  state: () => ({
    locale: null
  }),
  /**
   * @name getters
   * @type {object}
   * @getter {string} locale=locale Returns the current locale
   * @getter {string[]} locales=VueI18n.locales Returns array of the available locales found by webpack
   */
  getters: {
    locale: (state) => state.locale,
    locales: () => locales
  },
  actions: {
    /**
     * Change the current locale
     * @action setLocale=locale
     * @param {string} locale Locale to change to
     * @returns {void}
     */
    setLocale ({ commit }, locale) {
      commit('locale', locale);
    }
  },
  mutations: {
    locale (state, locale) {
      state.locale = locale;
    }
  }
};
